import { render, staticRenderFns } from "./IconsSettingsModal.vue?vue&type=template&id=09f641b4&scoped=true"
import script from "./IconsSettingsModal.vue?vue&type=script&lang=js"
export * from "./IconsSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./IconsSettingsModal.vue?vue&type=style&index=0&id=09f641b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f641b4",
  null
  
)

export default component.exports